/* eslint-disable no-unused-vars */
import useBreakpoint from '@/hooks/useBreakpoint';
import { Categoria } from '@/types/categoria';
import { CSSProperties } from 'react';
import ListagemCategoriasMobile from './Designs/Mobile';
import ListagemCategoriasDesktop from './Designs/Desktop';

export type ListagemCategoriasProps = {
  $key: string;
  $categorias: Array<Categoria>;
  $categoriaSelecionada: number;
  $funcaoCliqueCategoria: ({
    categoria,
    index,
  }: {
    categoria: Categoria;
    index: number;
  }) => void;
  style?: CSSProperties;
};

export default function ListagemCategorias(props: ListagemCategoriasProps) {
  const { breakpoint } = useBreakpoint();

  return breakpoint === 'mobile' ? (
    <ListagemCategoriasMobile {...props} />
  ) : (
    <ListagemCategoriasDesktop {...props} />
  );
}
